var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _line6, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "onion1",
    d: "M249.59,461c115.73,0,209.55-54.15,209.55-172,0-69.77-31.06-115.24-79.46-159.53C316.25,71,296.15,7.37,296.15,7.37H203S182.94,71,119.51,129.5C71.11,173.79,40.05,219.26,40.05,289,40.05,406.87,133.87,461,249.59,461Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "onion1",
    d: "M249.59,461c115.73,0,209.55-54.15,209.55-172,0-69.77-31.06-115.24-79.46-159.53C316.25,71,296.15,7.37,296.15,7.37H203S182.94,71,119.51,129.5C71.11,173.79,40.05,219.26,40.05,289,40.05,406.87,133.87,461,249.59,461Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "onion2",
    d: "M421.14,174.19c5.8,18.6,8.92,38.93,8.92,61.69,0,125.15-99.63,182.65-222.53,182.65C155.14,418.53,107,408.07,69,386.38,105.39,437.07,172.64,461,249.59,461c115.73,0,209.55-54.15,209.55-172C459.14,242.1,445.07,206.17,421.14,174.19Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "onion2",
    d: "M298.13,12.86c-1.36-3.53-2-5.49-2-5.49h-1.91C295.5,9.19,296.79,11,298.13,12.86Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "onion3",
    x1: 249.59,
    y1: 461.02,
    x2: 249.59,
    y2: 491.57
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "onion3",
    x1: 213.85,
    y1: 483.8,
    x2: 228.67,
    y2: 460.42
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "onion3",
    x1: 185.71,
    y1: 468.45,
    x2: 199.73,
    y2: 457.41
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "onion3",
    x1: 285.34,
    y1: 483.8,
    x2: 270.52,
    y2: 460.42
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "onion3",
    x1: 313.48,
    y1: 468.45,
    x2: 299.46,
    y2: 457.41
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "onion4",
    d: "M119.51,129.5S1.5,309.39,140.45,441.23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "onion4",
    d: "M156.3,89.64S31,317,192.72,456.26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "onion4",
    d: "M203,7.37s-126,287.77,18.22,452.53"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "onion4",
    d: "M245.81,461S140.45,296.09,232.67,7.37"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "onion4",
    d: "M379.68,129.5s118,179.89-20.94,311.73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "onion4",
    d: "M342.89,89.64S468.23,317,306.47,456.26"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "onion4",
    d: "M296.15,7.37s126,287.77-18.22,452.53"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "onion4",
    d: "M253.38,461S358.74,296.09,266.52,7.37"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "onion4",
    x1: 249.59,
    y1: 7.37,
    x2: 249.59,
    y2: 461.02
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "onion3",
    d: "M249.59,461c115.73,0,209.55-54.15,209.55-172,0-69.77-31.06-115.24-79.46-159.53C316.25,71,296.15,7.37,296.15,7.37H203S182.94,71,119.51,129.5C71.11,173.79,40.05,219.26,40.05,289,40.05,406.87,133.87,461,249.59,461Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnion);
export default __webpack_public_path__ + "static/media/Onion.72f8459ef9f0ea2a919dff32d30dad74.svg";
export { ForwardRef as ReactComponent };